






















































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule, routerModule, authModule } from '@/store';
import Wordpress, { RouteData } from '@/api/Wordpress';
import FooterCta from '@/components/frontend/FooterCta.vue';
import { ContactSubmission } from '@/api';

@Component({
  components: { FooterCta },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;
  success: boolean = false;
  error: string = '';

  page: RouteData | null = null;
  acfOptions: any = null;

  contact: ContactSubmission | null = null;

  requiredRule = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email must be valid',
  ];

  get title() {
    if (!this.page) {
      return;
    }
    return this.page.title.rendered;
  }

  get content() {
    if (!this.page) {
      return;
    }
    return this.page.content.rendered;
  }

  get featuredImage() {
    if (!this.page || !this.page.featured_image_sizes) {
      return;
    }
    return this.page.featured_image_sizes;
  }

  get acf() {
    if (!this.page) {
      return;
    }
    return this.page.acf;
  }

  sanitizePhone(phone: string) {
    const sanitizedPhone = phone.replace(/[\s)(]/g, '');
    return sanitizedPhone;
  }

  async save() {
    if (!this.contact) {
      return;
    }

    try {
      this.loading = true;
      await this.contact.save();
      this.error = '';
      this.success = true;
    } catch (e) {
      this.success = false;
      this.error = e.response.errors[0].detail;
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    this.contact = new ContactSubmission();

    if (authModule.isLoggedIn && authModule.user) {
      this.contact.name = authModule.user.customer.fullName;
      this.contact.email = authModule.user.customer.email;
      this.contact.phoneNumber = authModule.user.customer.phoneNumber;
    }

    try {
      this.page = await routerModule.getPage(this.$route.path);
      if (this.title) {
        const title = this.title + ' - Hobart Airport Parking';
        const titleElement = document.getElementsByTagName('title')[0];
        if (titleElement) {
          titleElement.innerHTML = title;
        } else {
          document.title = title;
        }

        authModule.trackPageview({
          gtag: this.$gtag,
          route: this.$route,
          pageTitle: decodeURI(this.title),
        });
      }
    } catch (err) {
      // Not found
      snackModule.showSnackbar('Page not found');
    }

    try {
      const optionsData = await Wordpress.getOptionsData();
      this.acfOptions = optionsData.acf;
    } catch (err) {
      // Error
    }
  }
}
